import { GetCapabilitiesService } from "./getCapabilities.service";
import { api } from "../../apiProvider";
import { parseXml } from "../../../common/util/xmlParser";
import { WfsCapabilities } from "./types";

export const getCapabilitiesAdapter: GetCapabilitiesService = async (params) => {
    const resp = await api.getCapabilities();
    return parseXml(resp.data as string) as WfsCapabilities;
};
